/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type ChatType = typeof ChatType[keyof typeof ChatType];


export const ChatType = {
  Direct: 'Direct',
  PrivateGroup: 'PrivateGroup',
  Broadcast: 'Broadcast',
  PublicGroup: 'PublicGroup',
  Feed: 'Feed',
  BroadcastFeed: 'BroadcastFeed',
} as const;
